module.exports = __webpack_public_path__ + "static/media/item_5_12_comp.5843b655.png";